import script from "./EditProfilePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProfilePage.vue?vue&type=script&setup=true&lang=ts"

import "./EditProfilePage.vue?vue&type=style&index=0&id=3445ae30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3445ae30"]])

export default __exports__